import { isFrontendUpdated } from "@/version-tracker";

export function useFrontendVersion() {
    const isUpdated = isFrontendUpdated();

    return {
        isFrontendUpdated: isUpdated,
    };
}
